module.exports = __webpack_public_path__ + "vco-icons.105c281f9303bd89d8f6.svg";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/storymap/icons/vco-icons.svg
// module id = ../../../../../src/styles/storymap/icons/vco-icons.svg
// module chunks = styles